import { render, staticRenderFns } from "./BlockClickable.vue?vue&type=template&id=383bfa00&"
import script from "./BlockClickable.vue?vue&type=script&lang=js&"
export * from "./BlockClickable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports